export const SET_PAGE = 'SET_PAGE';
export const CHANGE_PAGE = 'CHANGE_PAGE';
export const SET_STORY = 'SET_STORY';
export const GO_BACK = 'GO_BACK';
export const OPEN_POPOUT = 'OPEN_POPOUT';
export const CLOSE_POPOUT = 'CLOSE_POPOUT';
export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';
